import React from "react";
import { useSelector } from "react-redux";
import { Paper } from "@mui/material";

import useNotesFooter from "./useNotesFooter";
import IdtfToggle from "./components/IdtfToggle";
import SignStatus from "./components/SignStatus";
import NoteButtons from "./components/NoteButtons";
import PhysicianUnprocessModal from "./components/PhysicianUnprocessModal";
import { isReportSigned } from "utils/footerView.util";

const NotesFooter = ({ data }) => {
  const { reportDetail } = useSelector((state) => state.transmission);

  const { handleProcess, handleSignProcess } = useNotesFooter(data);

  const isSigned = isReportSigned(reportDetail);

  return (
    <Paper
      variant="outlined"
      style={{
        padding: "8px",
        zIndex: 1000,
      }}
      className="view-pdf__notes-footer"
    >
      <IdtfToggle patientId={data?.patient?._id} />

      <div className="view-pdf__notes-footer__row">
        {isSigned && <SignStatus />}

        <NoteButtons
          handleProcess={handleProcess}
          handleSignProcess={handleSignProcess}
        />

        <PhysicianUnprocessModal
          onConfirm={() => handleProcess("unprocess", false, true, false, true)}
        />
      </div>
    </Paper>
  );
};

export default NotesFooter;
